import React from "react";
import { useSelector } from "react-redux";
 

import { formatdatenotif } from "../../utils/utils_dates";

import { clicktransferemail } from "../../utils/transfermail";


import './DivOneMail.scss' ;

function  DivOneMail(){
   
    const emailchoice = useSelector(state=>state.email.emailchoice) ;
    return(<div className="divonemail">
                <div className="ecranmails_transfer" onClick={()=>clicktransferemail(emailchoice)} ></div>
                <div className="divonemail_titre" >{emailchoice?.Subject} </div>
                {emailchoice?.listattachements?.map((link, index) => (<a key={index} className="attachementlink" href={link} target="blank" >{link?.split('/')?.reverse()[0]}</a>))}
                <div className="divonemail_time"> {formatdatenotif(emailchoice?.created_at)}</div>  
                <div className="divonemail_content"  dangerouslySetInnerHTML={{ __html: emailchoice?.TextBody?.replaceAll('\n',' <br/>').replaceAll('\\n','<br/>') }} ></div>
        </div>)
}

export default DivOneMail;